import { render, staticRenderFns } from "./approval-drawer.vue?vue&type=template&id=1d31833f&"
import script from "./approval-drawer.vue?vue&type=script&lang=js&"
export * from "./approval-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports